import { Button } from '@servicecompressionllc/sc-design-system';
import { Toggle } from '../../components/Toggle.js';
import { usePushLogic } from './usePushLogic.js';

/** Settings: notifications on this device, a test, and how to undo a block. */
export const DeviceNotifications = () => {
  const push = usePushLogic();
  if (!push.available) return null;
  const on = push.permission === 'granted' && push.signedUp;
  return (
    <section className="grid gap-3 rounded-xl border border-outline bg-surface p-5">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h2 className="text-sm font-semibold text-ink">Notifications on this device</h2>
          <p className="text-sm text-ink-muted">
            Your bots let you know here when they message you, even with this page closed.
          </p>
        </div>
        <Toggle
          checked={on}
          onChange={() => (on ? push.turnOff() : push.turnOn())}
          label="Notifications on this device"
          disabled={push.isSwitching || push.permission === 'denied'}
        />
      </div>
      {push.permission === 'denied' && (
        <p className="text-sm text-ink-muted">
          This browser blocked notifications from this site. To turn them on, click the lock icon
          next to the address, allow notifications, and reload the page.
        </p>
      )}
      {on && (
        <div className="flex items-center gap-3">
          <Button
            size="sm"
            variant="secondary"
            disabled={push.test.isPending}
            onClick={push.sendTest}
          >
            Send a test
          </Button>
          {push.test.data && (
            <span className="text-sm text-ink-muted">
              {push.test.data.sent > 0
                ? 'Sent. It should appear in a moment.'
                : 'Nothing was sent. Turn notifications off and on again.'}
            </span>
          )}
        </div>
      )}
      {push.error && <p className="text-sm text-danger">{push.error.message}</p>}
    </section>
  );
};
